import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;
export const AmountBlock = styled.div<{ $isEmpty: boolean }>`
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  border: 2px solid ${({ theme }) => theme.palette.secondary};
  background: ${({ theme }) => theme.palette.white};
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ $isEmpty, theme }) =>
    $isEmpty
      ? css`
          border: 2px solid ${({ theme }) => theme.palette.gray60};
        `
      : css`
          border: 2px solid ${({ theme }) => theme.palette.secondary};
        `};
`;

export const TopBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const AvailabilityBlock = styled.div<{ $isEmpty: boolean }>`
  background: ${({ theme }) => theme.palette.secondaryLightest};
  padding: ${({ theme }) => `${theme.spacing.x1} ${theme.spacing.x2}`};
  border-end-start-radius: ${({ theme }) => theme.rounded.x3};
  text-align: center;
  max-width: 80px;
  flex-shrink: 0;
  ${({ $isEmpty, theme }) =>
    $isEmpty
      ? css`
          background: ${({ theme }) => theme.palette.boxBackgroundDark};
        `
      : css`
          background: ${({ theme }) => theme.palette.secondaryLightest};
        `};
`;
export const CabinClass = styled.p`
  text-align: center;
  flex-grow: 1;
  font-size: ${({ theme }) => theme.fs.sm};
  color: ${({ theme }) => theme.palette.darkGray};
`;
export const AvailabilityBlockText = styled.span`
  font-size: ${({ theme }) => theme.fs.xxs};
  color: ${({ theme }) => theme.palette.primary};
`;

export const Content = styled.div<{ $isEmpty: boolean }>`
  ${({ $isEmpty, theme }) =>
    $isEmpty
      ? css``
      : css`
          cursor: pointer;
        `};
`;
export const EmptyBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${({ theme }) => ` ${theme.spacing.x3} 0 `};
`;
export const EmptyBlockText = styled.span<{ $isEmpty: boolean }>`
  ${({ $isEmpty, theme }) =>
    $isEmpty
      ? css`
          color: ${({ theme }) => theme.palette.gray60};
        `
      : css`
          color: ${({ theme }) => theme.palette.secondary};
        `};

  font-size: ${({ theme }) => theme.fs.sm};
`;

export const AmountDetailsBlock = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.x3};
`;

const AmountDetailsData = styled.div<{ $isLTR: boolean }>`
  display: flex;
  align-items: flex-start;

  ${({ $isLTR }) =>
    !$isLTR
      ? css`
          flex-direction: row-reverse;
        `
      : null}
`;

export const AmountDetailsMiles = styled(AmountDetailsData)<{ $isLTR: boolean }>`
  ${({ $isLTR }) =>
    $isLTR
      ? css`
          justify-content: flex-start;
        `
      : css`
          justify-content: flex-end;
        `}
`;
export const AmountDetailsPrice = styled(AmountDetailsData)<{ $isLTR: boolean }>`
  ${({ $isLTR }) =>
    $isLTR
      ? css`
          justify-content: flex-end;
        `
      : css`
          justify-content: flex-start;
        `}
`;

export const AmountText = styled.span`
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: 700;
`;

export const SubText = styled.span`
  display: inline-block;
  vertical-align: super;
  padding-left: ${({ theme }) => theme.spacing.x2};
`;

export const AmountDetailsDescription = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.x2} 0;
`;

export const AmountBlockFloatBtn = styled.div<{ $onHover: boolean }>`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.x1} 0;
  background-color: ${({ theme }) => theme.palette.secondary};
  text-align: center;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  transition: ease all 0.2s;
  cursor: pointer;
  ${({ $onHover }) =>
    $onHover
      ? css`
          transform: translateY(0);
          opacity: 1;
        `
      : css`
          transform: translateY(100%);
          opacity: 0;
        `}
`;
